import { z } from 'zod'
import { personSchema } from './person'
import { addressSchema } from './address'
import { documentSchema } from './document'

/**
 * Schema completo para Client
 * Combina person + address + document + campos específicos
 */
export const clientSchema = personSchema
  .merge(addressSchema)
  .merge(documentSchema.partial()) // DNI opcional para clients
  .extend({
    // Campos específicos de Client
    estat: z.enum(['actiu', 'inactiu']).default('actiu'),
    professio: z.string().optional(),
    telefon_emergencia: z.string().optional(),
    contacte_emergencia: z.string().optional(),
    preferencies_alimentaries: z.string().optional(),
    allergies: z.string().optional(),
    notes: z.string().optional(),
    // Campos adicionales
    empresa: z.string().optional(),
    nif_empresa: z.string().optional(),
    idioma_preferit: z.string().optional(),
    consentiment_marketing: z.boolean().optional(),
  })

export type ClientFormData = z.infer<typeof clientSchema>

/**
 * Alta de client (`NouClientModal`): el document és opcional, però si hi ha número cal el tipus.
 * El `documentSchema` compartit exigeix número (és el dels viatgers) i el `'DNI'` que el modal
 * posava per defecte no és cap codi dels Mossos: sense tocar el document, l'alta no s'enviava.
 */
export const newClientSchema = clientSchema
  .extend({
    tipus_document: z.union([documentSchema.shape.tipus_document.removeDefault(), z.literal('')]).optional(),
    num_document: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.num_document?.trim() && !data.tipus_document) {
      ctx.addIssue({ code: 'custom', path: ['tipus_document'], message: 'Tria el tipus de document' })
    }
  })

/** Número de document com el desa el backend dels viatgers: sense espais i en majúscules */
export const normalizeDocumentNumber = (value: string | undefined): string =>
  (value ?? '').replace(/\s+/g, '').toUpperCase()
